import React, { useContext, useEffect, useState } from "react";
import FixelDataContext from "../../../../context/FixelDataContext";
import { StyledNoStats, StyledNotification } from "../../dashboard.style";
import { noStatsContent } from "../generateNotificationContent";
import NoStatsProgressBar from "./NoStatsProgressBar";

const NoStatsNotification = () => {
  const { fullFixelData } = useContext(FixelDataContext);
  const [content, setContent] = useState({});

  useEffect(() => {
    setContent(noStatsContent(fullFixelData.LAST_30_DAYS.fixelStats.total));
  }, [fullFixelData]);

  return (
    <StyledNotification type="noStats">
      <StyledNoStats>
        <h3>{content.title}</h3>
        <p>{content.massage}</p>
        <NoStatsProgressBar sessionsAnalyzed={content.sessionsAnalyzed} />
      </StyledNoStats>
    </StyledNotification>
  );
};

export default NoStatsNotification;
